<template>
  <div>
    <ClientDrugShoplistList
      title="Лист покупок"
      :prescriptions="tobuy"/>

    <ClientDrugShoplistList
      title="Куплено"
      :prescriptions="bought"/>
  </div>
</template>

<script>
import ClientDrugShoplistList from './shoplist/List';

export default {
  name: 'ClientDrugShoplist',

  props: ['prescriptions'],

  components: {ClientDrugShoplistList},

  data() {
    return {};
  },

  computed: {
    tobuy() {
      const items = this.prescriptions.filter(i => i.bought === false);

      items.sort((a, b) => a.startDate.getTime() - b.startDate.getTime());

      return items;
    },

    bought() {
      const items = this.prescriptions.filter(i => i.bought === false);

      items.sort((a, b) => b.startDate.getTime() - a.startDate.getTime());

      return items;
    },
  },
};
</script>
